import React from "react"
import styled from "styled-components"
import { normalizeExerciseId } from "../../util/strings"

const Heading = styled.div`
  & h1 {
    font-family: "Josefin Sans", sans-serif;
    font-weight: 600;
    font-size: clamp(40px, 4vw, 60px);
    color: #333;
  }
`

const H1 = ({ children }) => {
  let text = "unknown heading"
  try {
    text = children.find((o) => typeof o === "string") || "unknown heading"
  } catch (e) {}

  const id = `heading-${normalizeExerciseId(text)}`
  return (
    <Heading>
      <h1 className="material-header" id={id}>
        {" "}
        {children}{" "}
      </h1>{" "}
    </Heading>
  )
}

export default H1
